import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from 'react-router-dom';

class Guide extends Component {
  state = {
    data: []
  }

  render() {
    const { match, location, history } = this.props;

    return <Container>
      <h1>
        Metrics Guide
      </h1>
      <div>
        <h2>All new actor registration metrics</h2>
        <LinkList>
          <li><a style={{color:"green"}} href="/signups-explorer" onClick={(ev) => ev.preventDefault() || history.push("/signups-explorer")}>New Sign-ups metrics</a></li>
          <li><a style={{color:"green"}}  href="/signupsByRegion-explorer" onClick={(ev) => ev.preventDefault() || history.push("/signupsByRegion-explorer")}>New Sign-ups metrics by region</a></li>
          <li><a style={{color:"green"}}  href="/mobile-device-explorer" onClick={(ev) => ev.preventDefault() || history.push("/mobile-device-explorer")}>New Sign-ups mobile metrics</a></li>
        </LinkList>
        <h2>Paid only</h2>
        <LinkList>
          <li><a style={{color:"green"}}  href="/paid-explorer" onClick={(ev) => ev.preventDefault() || history.push("/paid-explorer")}>Only paid new Sign-ups metrics</a></li>
          <li><a href="/upgrades-explorer" onClick={(ev) => ev.preventDefault() || history.push("/upgrades-explorer")}>Upgrade to PRO metrics</a></li>
        </LinkList>
        <h2>Trial only</h2>
        <LinkList>
          <li><a style={{color:"green"}}  href="/trialSignupsWithRegion-explorer" onClick={(ev) => ev.preventDefault() || history.push("/trialSignupsWithRegion-explorer")}>Trial Sign-ups only</a></li>
          <li><a style={{color:"green"}}  href="/trialSignupsByRepWithRegion-explorer" onClick={(ev) => ev.preventDefault() || history.push("/trialSignupsByRepWithRegion-explorer")}>Trial Sign-ups by representation</a></li>
          <li><a href="/trialByPlan-explorer" onClick={(ev) => ev.preventDefault() || history.push("/trialByPlan-explorer")}>Total Trials by plan</a></li>
          <li><a href="/trialByRep-explorer" onClick={(ev) => ev.preventDefault() || history.push("/trialByRep-explorer")}>Total Trials by representation</a></li>
          <li><a href="/trialAccountType-explorer" onClick={(ev) => ev.preventDefault() || history.push("/trialAccountType-explorer")}>Total Trials by account type</a></li>
        </LinkList>

        <h2>
          Raw Data
        </h2>
        <LinkList>
          <li><a style={{color:"orange"}} href="/trialCancellation-explorer" onClick={(ev) => ev.preventDefault() || history.push("/trialCancellation-explorer")}>Cancellations / Downgrades</a></li>
          <li><a href="/trialAccounts-explorer" onClick={(ev) => ev.preventDefault() || history.push("/trialAccounts-explorer")}>All Trial Accounts</a></li>
        </LinkList>
        <h2>Conversion Metrics</h2>
        <LinkList>
          <li><a style={{color:"green"}}  href="/conversions-explorer" onClick={(ev) => ev.preventDefault() || history.push("/conversions-explorer")}>Sign-ups Conversions by day</a></li>
          <li><a href="/total-conversions" onClick={(ev) => ev.preventDefault() || history.push("/total-conversions")}>Total Conversions with Date filter</a></li>
        </LinkList>

      </div>

      <div>
        <br />
        <br />
      </div>
      <div style={{ opacity: 0.7 }}>
        <h2>
          OLD Metrics
        </h2>

        <div>
          <h3>Trial</h3>
          <LinkList>
              <li><a style={{color:"green"}}  href="/trialConversions-explorer" onClick={(ev) => ev.preventDefault() || history.push("/trialConversions-explorer")}>Trial Sign-ups conversions</a></li>
          </LinkList>
          <h3>Conversion</h3>
          <LinkList>
            <li><a href="/conversions-combined-explorer" onClick={(ev) => ev.preventDefault() || history.push("/conversions-combined-explorer")}>Total Conversions by day combined</a></li>
          </LinkList>
          <h3>PAYG</h3>
          <LinkList>
            <li><a style={{ textDecoration: 'line-through' }}
              href="/jobs-explorer" onClick={(ev) => ev.preventDefault() || history.push("/jobs-explorer")}>Jobs explorer (PAYG)</a></li>
          </LinkList>
          <h3>CWBLabs metrics</h3>
          <LinkList>
            <li><a style={{ textDecoration: 'line-through' }}
              href="/signupsLabs-explorer" onClick={(ev) => ev.preventDefault() || history.push("/signupsLabs-explorer")}>All Labs Metrics</a></li>
          </LinkList>
        </div>
      </div>
    </Container>
  }
}
const Container = styled.div`
  width: 80%;
  margin:24px auto;
`;

const LinkList = styled.ul`
    font-size:1.3rem;
`


export default withRouter(Guide);